import { render, staticRenderFns } from "./ShopChoice.vue?vue&type=template&id=d06f32d4&scoped=true"
import script from "./ShopChoice.vue?vue&type=script&lang=js"
export * from "./ShopChoice.vue?vue&type=script&lang=js"
import style0 from "./ShopChoice.vue?vue&type=style&index=0&id=d06f32d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06f32d4",
  null
  
)

export default component.exports